/*eslint-disable*/
import Flickity from 'flickity'

export default slider => {
  let $slider = $(slider)
  let isFlickity = false;
  let article_flkty;
  $slider.find('.collection__product_card').length < 2 && $slider.addClass('single-product')
  $slider.find('.collection__product_card').length === 4 && $slider.addClass('four-products')
  const setFlickity = slider => {
    isFlickity && $(slider).on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    isFlickity && $(slider).on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })
    if(window.matchMedia('(max-width:768px)').matches) {
      if(!isFlickity){        
        article_flkty = new Flickity(slider, {...params})
        isFlickity = !isFlickity;
      }
    } 
    else {
      if(isFlickity){
        article_flkty && article_flkty.destroy()
        isFlickity = !isFlickity;
      }
    }  
  }

  let params = {
    wrapAround: true,
    draggable: true,
    cellAlign: 'center',
    adaptiveHeight: true,
    prevNextButtons: false,
    imagesLoaded: true,
    on: {
      ready: ()=>{
        $slider.closest('.products-container').find('.explore').each((idx,explore)=> $(explore).click(()=>article_flkty.resize()))
      }
    }
  }

  $(window).on('load resize', ()=>{   
      setFlickity(slider)
      article_flkty && article_flkty.resize()
  })
}


// WEBPACK FOOTER //
// ./src/scripts/components/article-flickity.js